/* taio-opinie.js
   Okno z opiniami o sklepie. Widget eTrusted wstawiany dopiero przy pierwszym
   otwarciu, wiec do tego czasu nie kosztuje ani jednego zadania.
   Okno to natywny <dialog>, wiec Escape i blokada tla dzialaja bez naszego kodu. */
(function () {
  document.querySelectorAll('[data-tio-opinie]').forEach(function (przycisk) {
    var okno = przycisk.parentElement.parentElement.querySelector('[data-tio-opinie-okno]')
            || document.querySelector('[data-tio-opinie-okno]');
    if (!okno) return;
    var tresc = okno.querySelector('[data-tio-opinie-tresc]');
    var wstawiony = false;

    przycisk.addEventListener('click', function () {
      if (!wstawiony) {
        var w = document.createElement('etrusted-widget');
        w.setAttribute('data-etrusted-widget-id', przycisk.dataset.widget);
        tresc.appendChild(w);
        wstawiony = true;
      }
      if (typeof okno.showModal === 'function') { okno.showModal(); }
      else { okno.setAttribute('open', ''); }
    });

    var zamknij = okno.querySelector('[data-tio-opinie-zamknij]');
    if (zamknij) zamknij.addEventListener('click', function () { okno.close(); });

    /* klikniecie w tlo poza ramka zamyka okno */
    okno.addEventListener('click', function (e) {
      if (e.target === okno) okno.close();
    });
  });
})();
